import { render, staticRenderFns } from "./resultado-evaluacion.vue?vue&type=template&id=dabd27c4&"
import script from "./resultado-evaluacion.component.ts?vue&type=script&lang=ts&"
export * from "./resultado-evaluacion.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports